export default Object.freeze({
	ucNone: 0,
	ucUnused: 1,
	ucPurchasePostage: 2,
	ucEditReferenceCodes: 4,
	ucReferenceCodeOptional: 8,
	ucPurchaseFromStore: 16,
	ucClientLogin: 32,
	ucmUserRoleDefault: 32,
	ucManageUsers: 64,
	ucChangePhysicalAddress: 128,
	ucChangePaymentMethod: 256,
	ucChangeServicePlan: 512,
	ucWebBasedReports: 1024,
	ucmReportsRoleDefault: 1024,
	ucFedEx: 2048,
	ucFedExSubscription: 4096,
	ucmManualCaps: 6174,
	ucChangeContactInfo: 8192,
	ucChangeShippingAddress: 16384,
	ucAdvancedReporting: 32768,
	ucEditShipmentNotificationCustomization: 65536,
	ucmAdminRoleDefault: 95172,
	ucmAll: 131071,
	ucAccountOwner: 262144,
});
